import TripLateralLoader from '../TripLateralLoader';
import BusPackage from '@itinerary/trip/bus/BusPackage';
import { ReserveType } from '@utils/itinerary';
import { GetServicesApiApiGetServicesCuratedPost } from '@clients/BusApi';

export class TaxiLateralLoader extends TripLateralLoader {
    codeMapping: Record<string, string> = {
        THR: '11320000', // Tehran
        RAS: '54310000', // Rasht
        IFN: '21310000', // Isfahan
        NSH: '16450000', // Now-Shahr
        RZR: '16390000', // Ramsar
        QQM: '14310000', // Qom
        GBT: '97310000', // Gorgan
        SRY: '16310000', // Sorry
        CQD: '77310000', // Shahr-e-Kord
        KKS: '21420000', // Kashan
        SDG: '73310000', // Sanandaj
        KSH: '71310000', // Kermanshah
        AJK: '51310000', // Arak
        SNX: '87310000', // Semnan
        JWN: '67310000', // Zanjan
        HDM: '75310000', // Hamedan
        1: '11320000', // Tehran
        451: '54310000', // Rasht
        21: '21310000', // Isfahan
        161: '14310000', // Qom
        175: '97310000', // Gorgan
        100: '16310000', // Sorry
        162: '21420000', // Kashan
        195: '71310000', // Kermanshah
        14: '51310000', // Arak
        116: '87310000', // Semnan
        97: '67310000', // Zanjan
        117: '75310000', // Hamedan
        11320000: '11320000', // Tehran
        54310000: '54310000', // Rasht
        21310000: '21310000', // Isfahan
        16460000: '16460000', // Chaloos
        16450000: '16450000', // Now-Shahr
        16380000: '16380000', // Ton-e-Kabon
        16390000: '16390000', // Ramsar
        54450000: '54450000', // Lahijan
        14310000: '14310000', // Qom
        97310000: '97310000', // Gorgan
        16310000: '16310000', // Sorry
        16320000: '16320000', // Amol
        16330000: '16330000', // Babol
        16340000: '16340000', // Babolsar
        11362023: '11362023', // Imam Apt
        77310000: '77310000', // Shahr-e-Kord
        21420000: '21420000', // Kashan
        73310000: '73310000', // Sanandaj
        71310000: '71310000', // Kermanshah
        51310000: '51310000', // Arak
        87310000: '87310000', // Semnan
        67310000: '67310000', // Zanjan
        75310000: '75310000', // Hamedan
    };

    override async loadItineraries(params: {
        originCode: string;
        destinationCode: string;
        date: Date;
        count: number;
    }): Promise<BusPackage[]> {
        const originCode = this.codeMapping[params.originCode.toString()];
        const destinationCode =
            this.codeMapping[params.destinationCode.toString()];
        if (!originCode || !destinationCode) {
            return [];
        }

        const { data } = await GetServicesApiApiGetServicesCuratedPost(
            {
                getServicesRequest: {
                    from: parseInt(originCode),
                    to: parseInt(destinationCode),
                    date: dayConfig.gregory(params.date).format(formatter()),
                    count: params.count,
                    includeClosed: true,
                    includePromotions: true,
                    loadFromDbOnUnavailability: true,
                    includeUnderDevelopment: false,
                    providerId: 8,
                    excludeProviderIds: [],
                },
            },
            {
                timeout: 5000,
            }
        );

        return (
            data.buses?.map(
                bus => new BusPackage(bus, params.count, true, ReserveType.Taxi)
            ) || []
        );
    }
}
